import { render, staticRenderFns } from "./layout-body.vue?vue&type=template&id=8a4375ba&scoped=true&"
import script from "./layout-body.vue?vue&type=script&lang=js&"
export * from "./layout-body.vue?vue&type=script&lang=js&"
import style0 from "./layout-body.vue?vue&type=style&index=0&id=8a4375ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4375ba",
  null
  
)

export default component.exports